<template>
  <a-card :bordered="false">
    <a-form ref='form' :model='search' :style="{'marginBottom':'10px'}" :initialValues="search"
      :onFinish='pageSearchChange' :wrapper-col="{span:20}">
      <a-form-item label="是否立即扫码" class='mb15'>
        <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="detail.is_scan_code_immediately" />
      </a-form-item>
      <app-warp :title='detail.title ?detail.title:"防伪查询"'>
        <template #app-content>
          <div class="pic_content" :style="'background-color:'+detail.cover_color">
            <img class="width100" v-if='detail.cover_image_url' style="display: block;height: auto;"
              :src="info.picdomain+detail.cover_image_url" alt="">
            <div class="scanBnt width100 p-20">
              <div class="width80 height-40 s_flex_center bor-rad-20 s_cfff fz-16"
                :style="'margin: 0 auto;background-color:'+detail.button_color">{{detail.button_name}}</div>
            </div>
          </div>
        </template>
        <template #app-sider>
          <div class="width95 s_flex_end m-l-20 m-b-20">
            <a-button type="primary" ghost v-has:scanPageConfigCopyUrl='getCopyUrl'>复制链接</a-button>
          </div>
          <div class="moduleContent " style="width:95%;margin-left:20px">
            <a-form-item label="页面标题" class='mb15' name='keyword' :label-col="{span:3}" :wrapper-col="{span:10}">
              <a-input v-model:value="detail.title" placeholder="请输入页面标题" style="width:250px" :maxlength='6'></a-input>
            </a-form-item> 
            <a-form-item label="背景图片" class='mb15' name='keyword' :label-col="{span:3}" help="推荐尺寸750*1334">
              <material :groupType='1' :image="detail.cover_image_url" :max="1" v-on:handlechoose="(data)=>{
                  detail.cover_image_url=data}" v-on:handledel="delPic" />
            </a-form-item>
            <a-form-item label="页面背景色" help="页面整体背景色" :label-col="{span:3}">
              <div >
                <a-input v-model:value="detail.cover_color" type="color" style="width:150px" />
                <a-button class="m-l-15" type="primary" @click='detail.cover_color = "#f5f5f5"'>恢复默认值</a-button>
              </div>
            </a-form-item>
            <a-form-item label="按钮颜色" :label-col="{span:3}">
              <a-input v-model:value="detail.button_color" type="color" style="width:150px" />
            </a-form-item>
            <a-form-item label="按钮文字" class='mb15' name='keyword' :label-col="{span:3}">
              <a-input v-model:value="detail.button_name" placeholder="请输入按钮文字" style="width:250px" :maxlength='6' >
              </a-input>
            </a-form-item>
          </div>
          <a-button type="primary" v-has:scanPageConfigSubmit="update" class='m-l-20 m-t-30'>保存</a-button>
        </template>
      </app-warp>
    </a-form>
  </a-card>
  <a-modal :keyboard="false" title="复制链接" centered :width='800' :footer="null" v-model:visible="showUrl">
    <div class="s_flex_bian_c">
      <div class="s_bor_r_cd9 p-r-20">
        <a-spin :spinning="spinning">
          <div class="width-160 height-160" id="qrcode"></div>
        </a-spin>
        <p class="text-ac m-t-10">微信扫一扫立即预览</p>
      </div>
      <div class="width70">
        <p class="s_c333 s_font_b fz-16">复制地址</p>
        <div class="m-t-15 m-b-15 s_flex_bian_c">
          <a-input class="width80" v-model:value="copyUrl" readonly></a-input>
          <a-button class="copy-btn" type="primary" ghost @click="copy" :data-clipboard-text="copyUrl">复制</a-button>
        </div>
        <p class="s_c999 ">可将链接复制到您的公众号菜单中</p>
      </div>
    </div>
  </a-modal>
</template>
<script>
  import Clipboard from 'clipboard';
  import { getScanPageDetail, setScanPageDetail,getScanPageUrl } from "@/api/qrcodeActivitys";
  import { iscode } from "@/utils/app";
  import { onMounted, ref } from "@vue/runtime-core";
  import store from '@/store'
  import { qrcanvas } from 'qrcanvas';
  import { message } from "ant-design-vue";
  export default {
    setup() {
      const detail = ref({
        is_scan_code_immediately: 0,
        title: '防伪查询',
        cover_image_url: "",
        cover_color: '#f5f5f5',
        button_color: '#F85F24',
        button_name: '立即扫码'
      });
      const copyUrl= ref('')
      const showUrl= ref(false)
      const spinning = ref(false)
      const initData = async () => {
        let result = await getScanPageDetail().then((res) => res.data).catch((error) => error);
        if (iscode(result, true, false)) {
          detail.value = result.data;
        }
      };
      const update = async () => {
        let result = await setScanPageDetail({ ...detail.value, is_scan_code_immediately: detail.value.is_scan_code_immediately ? 1 : 0 }).then((res) => res.data).catch((error) => error);
        if(iscode(result, true)){
          initData();
        }
      };
      const delPic = () => {
        detail.value.cover_image_url = ''
      }
      const getCopyUrl = async () => {
        spinning.value = true
        let result = await getScanPageUrl().then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          copyUrl.value = result.data.url;
          showUrl.value = true
          setTimeout(()=>{
            var canvas = qrcanvas({
              data: copyUrl.value ,
              size:160,
            })
            document.getElementById('qrcode').innerHTML = '';
            document.getElementById('qrcode').appendChild(canvas);
            spinning.value = false
          },500)
        }
      };
      // 复制
      const copy = (link) => {
        let clipboard = new Clipboard(".copy-btn"); // 这里括号里填写上面点击事件绑定的class名
        clipboard.on("success", e => {
          message.success("复制成功")
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", e => {
          message.error("该浏览器不支持自动复制")
          // 释放内存
          clipboard.destroy();
        });
        showUrl.value = false
      };
      onMounted(() => {
        initData();
      });
      return {
        detail,
        update,
        info: store.state.user.info,
        delPic,
        copyUrl,
        showUrl,
        copy,
        getCopyUrl,
        spinning
      };
    },
  };
</script>

<style lang="less" scoped>
  .moduleContent {
    height: auto;
    background: #fdfdfd;
    border: 1px solid #ddd;
    padding: 20px 10px 40px 10px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    user-select: none;
  }

  .pic_content {
    position: relative;
    height: 100%;
  }

  .scanBnt {
    position: absolute;
    left: 0;
    bottom: 180px;
  }
</style>